import React, { useState, useEffect, useRef } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { validateToken, callApi } from "../../../lib/utils";
import axios from "axios";
import moment, { duration } from "moment";
import { useSelector } from "react-redux";
import "./AbnormalMotionHeader.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLocationDot,
  faChartSimple,
} from "@fortawesome/free-solid-svg-icons";
import GenericModal from "../../GenericComponents/GenericModal/GenericModal";
import { Chart } from "react-google-charts";
import TaskNotes from "../../GenericComponents/TaskNotes";
import { OverlayTrigger, Popover, Tooltip } from "react-bootstrap";
import { Wrapper, Status } from "@googlemaps/react-wrapper";
import { unionBy } from "lodash";
import AbnormalMotionEventGraph from "../../GenericComponents/EventSpecificGraph/AbnormalMotionEventGraph";

const AMeventList = ({ ...props }) => {
  const [showModal, setShowModal] = useState(false);
  const [showGraphModal, setShowGraphModal] = useState(false);
  const [modalData, setModalData] = useState({});
  const [graphMomdalData, setGraphModalData] = useState({});
  const [showNotesModal, setShowNotesModal] = useState(false);
  const [notesModalData, setNotesModalData] = useState({});
  const profileData = useSelector((state) => state?.dashboard);
  const [loading, setLoading] = useState(false);
  const [blobFile, setBlobFile] = useState(false);

  const dateFormatter = (cell, row) => {
    return `${moment(row.eventTimestamp).format("MM/DD/YYYY")}   ${moment(
      row.eventTimestamp
    ).format("hh:mm A")}`;
  };

  const classificationFormatter = (cell, row) => {
    if (row?.eventClassifiedAs === null) return <span> Not Classified</span>;
    else if (row?.eventClassifiedAs === "N")
      return <span> Not An Actual Event</span>;
    else if (row?.eventClassifiedAs === "T") return <span> Test Event</span>;
    else if (row?.eventClassifiedAs === "F")
      return <span> False Alarm</span>;
    else if (row?.eventClassifiedAs === "A") return <span> Actual Event</span>;
  };

  // const classificationFormatter = (cell, row) => {
  //   if (
  //     row?.isTestEvent === false &&
  //     row?.isFalseAlarmEvent === false &&
  //     row?.eventClassifiedAs === "A"
  //   )
  //     return <span> Actual Event</span>;
  //   else if (
  //     row?.isTestEvent === false &&
  //     row?.isFalseAlarmEvent === true &&
  //     row?.eventClassifiedAs === "N"
  //   )
  //     return <span> Not An Actual Event</span>;
  //   else if (
  //     row?.isTestEvent === true &&
  //     row?.isFalseAlarmEvent === null &&
  //     row?.eventClassifiedAs === "T"
  //   )
  //     return <span> Test Event</span>;
  //   else if (
  //     row?.isTestEvent === null &&
  //     row?.isFalseAlarmEvent === null &&
  //     row?.eventClassifiedAs === "F"
  //   )
  //     return <span> Not Classified</span>;
  // };

  const srNumberFormatter = (cell, row, rowIndex) => {
    if (props.currentPage > 1)
      return <>{props.perPage * (props.currentPage - 1) + (rowIndex + 1)}</>;
    else return <>{rowIndex + 1}</>;
  };
  const locationFormatter = (cell, row) => {
    return !!profileData?.appModules?.active?.GPS?.length &&
      !profileData?.appModules?.inactive?.GPS?.length &&
      row?.address ? (
      //   <OverlayTrigger
      //     placement="top"
      //     overlay={
      //       <Tooltip id="button-tooltip-location">Click To View Location</Tooltip>
      //     }
      //   >
      //     <div className="location-content">
      //       <FontAwesomeIcon icon={faLocationDot} style={{ cursor: "pointer" }}/>
      //     </div>
      //   </OverlayTrigger> :"-"
      // );
      <OverlayTrigger
        placement="right"
        overlay={
          <Popover
            id="popover-location"
            placement="right"
            // positionLeft={200}
            // positionTop={50}
            bsClass="popover-location"
          >
            {row?.address}
          </Popover>
        }
        trigger="click"
      >
        <label className="location-content" title={row?.address}>
          {row?.address}
          {/* <FontAwesomeIcon icon={faLocationDot} style={{ cursor: "pointer" }} /> */}
        </label>
      </OverlayTrigger>
    ) : (
      "-"
    );
  };
  const graphFormatter = (cell, row) => {
    return (
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id="button-tooltip-location">
            Click To View Event Graph
          </Tooltip>
        }
      >
        <div className="graph-content">
          <FontAwesomeIcon icon={faChartSimple} style={{ cursor: "pointer" }} />
        </div>
      </OverlayTrigger>
    );
  };
  const heartRateFormatter = (cell, row) => {
    return (
      <table style={{ width: "100%" }}>
        <tr>
          <td>{row?.minHr ? row?.minHr : "-"}</td>
          <td>{row?.maxHr ? row?.maxHr : "-"}</td>
          <td>{row?.avgHr ? row?.avgHr : "-"}</td>
        </tr>
      </table>
    );
  };
  const heartRateHeaderFormatter = (column, colIndex) => {
    return (
      <table className="table-header">
        <tr className="table-header-heading">
          <td colSpan={3}>Heart Rate</td>
        </tr>
        <tr className="table-header-subheading">
          <td>Min</td>
          <td>Max</td>
          <td>Avg</td>
        </tr>
      </table>
    );
  };
  const handleShowModal = (show, data) => {
    if (show) {
      setModalData(data);
    } else {
      setModalData({});
    }
    setShowModal(show);
  };

  const handleShowGraphModal = (show, data) => {
    if (show) {
      validateToken((err) => {
        if (err) {
          // console.log(err);
          window.location = "/logout";
        }
        callApi(
          `/api/patient/events/abnormal-motion/sensor-data/${data.id}`,
          {},
          "GET"
        )
          .then((response) => {
            setGraphModalData(response?.data?.data);
          })
          .catch((err) => {
            console.log("err: ", err);
          });
      });
    } else {
      setGraphModalData({});
    }
    setShowGraphModal(show);
  };
  const severityHeaderFormatter = (coloumn, colIndex) => {
    return (
      <table className="table-header">
        <tr className="table-header-heading">
          <td colSpan={2}>SEVERITY</td>
        </tr>
        <tr className="table-header-subheading">
          <td>Amplitude</td>
          <td>Frequency</td>
        </tr>
      </table>
    );
  };
  const severityFormatter = (cell, row) => {
    return (
      <table style={{ width: "100%" }}>
        <tr>
          <td className="severity-values">
            {row?.severityByAmplitude ? row?.severityByAmplitude : "-"}
          </td>
          <td className="severity-values">
            {row?.severityByFrequency ? row?.severityByFrequency : "-"}
          </td>
        </tr>
      </table>
    );
  };
  const getAudioPlayerFormatter = (cell, row) => {
    return row?.isAudioFileDeleted === "N" &&
      !!profileData?.appModules?.active?.ADORE?.length &&
      !profileData?.appModules?.inactive?.ADORE?.length ? (
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id="button-tooltip-audio-recording">
            Click To Play Audio Recording
          </Tooltip>
        }
      >
        <div style={{ cursor: "pointer" }}>
          <audio
            style={{
              maxWidth: "150px",
              opacity: row?.isAudioFileDeleted === "N" ? "1" : "0.5",
              cursor: "pointer",
            }}
            controls
            name="media"
          >
            <source
              src={
                row?.isAudioFileDeleted === "N"
                  ? `/upload/patient/web/abnormal-motion/audio/${row?.id}`
                  : ""
              }
              type="audio/mp3"
            />
          </audio>
        </div>
      </OverlayTrigger>
    ) : (
      "-"
      // <div style={{ cursor: "pointer" }}>
      //   <audio
      //     style={{
      //       maxWidth: "150px",
      //       opacity: (row?.isAudioFileDeleted === "N" && !!profileData?.appModules?.active?.ADORE?.length && !profileData?.appModules?.inactive?.ADORE?.length) ? "1" : "0.5",
      //       cursor: "pointer",
      //     }}
      //     controls
      //     name="media"
      //   >
      //     <source
      //       src={
      //         (row?.isAudioFileDeleted === "N" && !!profileData?.appModules?.active?.ADORE?.length && !profileData?.appModules?.inactive?.ADORE?.length)
      //           ? `/upload/patient/web/abnormal-motion/audio/${row?.id}`
      //           : ""
      //       }
      //       type="audio/mp3"
      //     />
      //   </audio>
      // </div>
    );
  };
  const notesFormatter = (cell, row) => {
    return (
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip id="button-tooltip-3">Click To View Notes</Tooltip>}
      >
        <img
          src="/images/pharmacy_workspace/notes_black_icn@2x.png"
          alt=""
          className="iconStyle"
          style={{ cursor: "pointer" }}
        />
      </OverlayTrigger>
    );
  };
  const durationFormatter = (cell, row) => {
    return (
      <span>
        {!!row?.totalEventDuration &&
          Math.floor(row?.totalEventDuration / 60) !== 0 &&
          moment({
            hour: 0,
            minute: row.totalEventDuration / 60,
            seconds: row.totalEventDuration % 60,
            milliseconds: 0,
          }).format("mm")}
        {!!(Math.floor(row?.totalEventDuration / 60) !== 0) && <> min </>}
        {!!row?.totalEventDuration &&
          moment({
            hour: 0,
            minute: row.totalEventDuration / 60,
            seconds: row.totalEventDuration % 60,
            milliseconds: 0,
          }).format("ss")}{" "}
        secs
      </span>
    );
  };

  const actionFormatter = (cell, row) => {
    return (
      <div>
        <a
          title="Click to download report"
          style={{ cursor: "pointer" }}
          //onClick={downlaodReport(row)}
        >
          <i class="fa fa-download"></i>
        </a>
      </div>
    );
  };

  const downlaodReport = (data) => {
    setLoading(true);
    axios({
      method: "get",
      url: `/upload/export/pdf/abnormal-motion/graph/${data.id}`,
      responseType: "blob",
    })
      .then((response) => {
        var filename = "";
        let disposition = null;

        if (Object.keys(response.headers).includes("content-disposition")) {
          disposition = response.headers["content-disposition"];
        } else if (
          Object.keys(response.headers).includes("Content-Disposition")
        ) {
          disposition = response.headers["Content-Disposition"];
        }

        // var disposition = xhr.getResponseHeader('Content-Disposition');
        if (disposition && disposition.indexOf("attachment") !== -1) {
          var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          var matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, "");
          }
        }
        let blobData = response.data;
        setLoading(false);
        setBlobFile(blobData);
        fileDownload(filename, blobData);
        //fileDownload(response.data, id + ".xlsx");
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const fileDownload = (filename, blobData) => {
    var type = "";
    var blobURL = window.URL.createObjectURL(blobData);
    var tempLink = document.createElement("a");
    tempLink.style.display = "none";
    tempLink.href = blobURL;
    tempLink.setAttribute(
      "download",
      filename !== ""
        ? `${filename}`
        : type === "xlsx"
        ? "report.xlsx"
        : "report.pdf"
    );

    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
    window.URL.revokeObjectURL(blobURL);
  };

  const handleShowNotesModal = (show, data) => {
    if (show) {
      setNotesModalData(data);
    } else {
      setNotesModalData({});
    }
    setShowNotesModal(show);
  };

  const columns = [
    {
      dataField: "id",
      text: "No.",
      formatter: srNumberFormatter,
      headerStyle: () => {
        return { width: "48px", paddingLeft: "18px" };
      },
    },
    {
      dataField: "eventTimestamp",
      text: "EVENT DATE/TIME",
      formatter: dateFormatter,
    },
    {
      dataField: "isFalseAlarmEvent",
      text: "CLASSIFICATION",
      headerStyle: () => {
        return { width: "120px" };
      },
      formatter: classificationFormatter,
    },
    {
      dataField: "totalEventDuration",
      text: "DURATION",
      formatter: durationFormatter,
    },
    {
      dataField: "severity",
      text: "SEVERITY",
      headerFormatter: severityHeaderFormatter,
      formatter: severityFormatter,
    },
    {
      dataField: "eventGraph",
      text: "EVENT GRAPH",
      formatter: graphFormatter,
      headerStyle: () => {
        return { width: "164px" };
      },
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          handleShowGraphModal(true, row);
        },
      },
      id: "graphButton",
    },
    {
      dataField: "notes",
      text: "NOTES",
      formatter: notesFormatter,

      headerStyle: () => {
        return { width: "120px" };
      },
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          handleShowNotesModal(true, row);
        },
      },
    },
    {
      dataField: "location",
      text: "LOCATION",
      formatter: locationFormatter,
      headerStyle: () => {
        return { width: "120px" };
      },
      // events: {
      //   onClick: (e, column, columnIndex, row, rowIndex) => {
      //     handleShowModal(true, row);
      //   },
      // },
      id: "locationButton",
    },
    {
      dataField: "Audio Recording",
      text: "AUDIO RECORDING",
      formatter: getAudioPlayerFormatter,
    },
    {
      dataField: "heartRate",
      //text: "<td>HEART RATE<td>",
      formatter: heartRateFormatter,
      headerFormatter: heartRateHeaderFormatter,
    },
    {
      dataField: "action",
      text: "ACTION",
      formatter: actionFormatter,
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          downlaodReport(row);
        },
      },
    },
  ];

  const MyMapComponent = ({ center, zoom }) => {
    const ref = useRef();

    useEffect(() => {
      new window.google.maps.Map(ref.current, {
        center,
        zoom,
      });
    });

    return (
      <div ref={ref} id="map1" style={{ height: "750px", width: "98%" }} />
    );
  };
  const mapStatus = (status) => {
    if (status === Status.FAILURE) return <div>Status: ${Status.FAILURE}</div>;
    //return <Spinner />;
  };

  const GoogleMap = (props) => {
    return (
      !!props.data?.latitude &&
      !!props.data?.longitude && (
        <Wrapper
          apiKey={"AIzaSyBZ-neHCssh_jPwQExqLW-KRfucDUaxIq8"}
          render={mapStatus}
        >
          <MyMapComponent
            center={{ lat: props.data?.latitude, lng: props.data?.longitude }}
            zoom={4}
          />
        </Wrapper>
      )
    );
  };
  const LineGraph = (props) => {
    const heartRate = props.graphData?.sensorData?.processedHrData?.filter(
      (item, index) => item.y !== 0
    );
    const graphData = [
      ...(props.graphData?.sensorData?.formattedData &&
      props.graphData?.sensorData?.formattedData?.length &&
      !!props.graphData?.sensorData?.formattedData
        ? props.graphData?.sensorData?.formattedData
        : heartRate?.length
        ? heartRate
        : []),
    ];

    const result = unionBy(heartRate, graphData, "x");

    const newData = result?.map((item, index) => {
      let temp = undefined;
      let sec = undefined;
      let isHeartRateValueExists = false;
      if (heartRate[index]?.y !== undefined) {
        temp = heartRate[index]?.y;
        sec = heartRate[index]?.x;
        isHeartRateValueExists = true;
      }
      if (sec === undefined) {
        sec = item.x;
      }
      if (temp === 0) {
        temp = undefined;
      }
      return !!heartRate?.length
        ? [sec, item?.y && !isHeartRateValueExists ? item?.y : 0, temp]
        : [sec, item?.y ? item?.y : 0];
    });

    const paramData = !!heartRate?.length
      ? ["Motion Monitoring", "Heart Rate"]
      : ["Motion Monitoring"];
    const data = [
      [
        { type: "number", label: "Motion Monitoring Duration ( In Secs )" },
        ...paramData,
      ],
      ...newData,
    ];
    // const options = {
    //   title: "Abnormal Motion Amplitude",
    //   width: "100%",
    //   height: 500,
    //   legend: "bottom",
    //   series: !!heartRate?.length
    //     ? {
    //         0: { targetAxisIndex: 0, type: "line", axis: "AbnormalMotion" },
    //         1: { targetAxisIndex: 1, type: "scatter", axis: "HeartRate" },
    //       }
    //     : {
    //         0: { targetAxisIndex: 0, type: "line", axis: "AbnormalMotion" },
    //       },
    //   axes: {
    //     y: !!heartRate?.length
    //       ? {
    //           AbnormalMotion: { label: "Abnormal Motion" },
    //           HeartRate: { label: "Heart Rate" },
    //         }
    //       : { AbnormalMotion: { label: "Abnormal Motion" } },
    //   },
    //   // vAxes: !!heartRate?.length
    //   //   ? {
    //   //       0: { title: "Abnormal Motion" },
    //   //       1: { title: "Heart Rate" },
    //   //     }
    //   //   : { 0: { title: "Abnormal Motion" } },
    //     vAxes:!!heartRate?.length?{
    //       0: {title: 'Abnormal Motion' ,format:'0'},
    //       1: {title: 'Heart Rate',format:'0', minValue: heartRate[0].y-5,
    //       maxValue: heartRate[heartRate?.length-1].y+5}}:{0: {title: 'Abnormal Motion'}},
    //   hAxis: {
    //     title: "Abnormal Motion Duration ( In Secs )",
    //   },
    //   colors: ["#5CB3FF", "#E42217"],
    // };

    return (
      <AbnormalMotionEventGraph
        data={data}
        heartRateData={heartRate}
        loading={!newData?.length}
        eventData={newData}
      />
    );
  };

  return (
    <>
      <div>
        <BootstrapTable
          keyField="id"
          wrapperClasses="drilldown-list-table-wrapper"
          classes="drilldown-list-table drilldown-list-table--am"
          data={
            props.amEventsList?.length
              ? props.amEventsList.sort((t1, t2) => {
                  if (t1.eventTimestamp > t2.eventTimestamp) return -1;
                  if (t1.eventTimestamp < t2.eventTimestamp) return 1;
                  return 0;
                })
              : []
          }
          columns={columns}
          striped
          hover
          condensed
          bordered={false}
        />
        <GenericModal
          key="map"
          showModal={showModal}
          handleShowModal={handleShowModal}
          ChildComponent={<GoogleMap data={modalData} />}
        />
        <GenericModal
          key="showgraph"
          showModal={showGraphModal}
          handleShowModal={handleShowGraphModal}
          ChildComponent={<LineGraph graphData={graphMomdalData} />}
        />
        <GenericModal
          key="notes"
          showModal={showNotesModal}
          handleShowModal={handleShowNotesModal}
          ChildComponent={
            <TaskNotes
              data={notesModalData}
              payload={{
                patientId: notesModalData?.patientId,
                noteModuleId: 1,
                referenceId: notesModalData?.id,
                eventTypeId: parseInt(notesModalData?.eventType),
                patientTaskId: null,
              }}
              patientData={profileData?.profileData?.patientData}
            />
          }
          variant={"white"}
        />
      </div>
    </>
  );
};

export default AMeventList;
